import React, {Component} from 'react';
import PropTypes from 'prop-types';
import LassoIcon from './LassoIcon';
import LassoInverseIcon from './LassoInverseIcon';
import {Button} from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import Mousetrap from 'mousetrap';
import {BRUSH, FREEHAND, INVERSE, LASSO, RECT} from 'rc-canvas/lib/DrawingModes';
import RectInverseIcon from './RectInverseIcon';
import RectIcon from './RectIcon';
import {BRUSHES} from '../Constants';

export default class PaintModePicker extends Component {
    static propTypes = {
        mode: PropTypes.string,
        shape: PropTypes.oneOf([RECT, FREEHAND, null]),
        brushSize: PropTypes.number,
        onModeChanged: PropTypes.func,
        onBrushCycle: PropTypes.func,
        onLassoCycle: PropTypes.func,
        onBrushSizeChange: PropTypes.func,
    };

    componentDidMount() {
        const {onBrushCycle, onLassoCycle} = this.props;
        Mousetrap.bind('b', (e) => {
            e.preventDefault();
            onBrushCycle();
        });

        Mousetrap.bind('B', (e) => {
            e.preventDefault();
            onBrushCycle(true);
        });

        Mousetrap.bind('l', (e) => {
            e.preventDefault();
            onLassoCycle();
        });

        Mousetrap.bind('L', (e) => {
            e.preventDefault();
            onLassoCycle(true);
        });
    }


    componentWillUnmount() {
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind(['b', 'l']);
    }

    renderBrushButton = ({size, label}) => {
        const {mode, brushSize, onBrushSizeChange} = this.props;

        return (
            <Button
                active={mode === BRUSH && brushSize === size}
                onClick={() => onBrushSizeChange(size)}
                data-tip
                data-for="brushTooltip"
                key={label}
                className={`btn-brush-${label} btn-brush`}
            >
                <i className="fa fa-circle"/>
            </Button>
        );
    };

    render() {
        const {onModeChanged, mode, shape, brushSize, onBrushSizeChange, onBrushCycle, onLassoCycle, ...rest} = this.props;

        const iconStyle = {height: 20, width: 20};
        return (
            <div className="paint-mode-picker">
                <div {...rest} className="edit-modes btn-group btn-matrix-2">
                    {this.renderBrushButton(BRUSHES[0])}
                    <Button
                        active={mode === LASSO && shape !== RECT}
                        data-tip
                        data-for="lassTooltip"
                        className="btn-lasso"
                        onClick={() => onModeChanged(LASSO, FREEHAND)}
                    >
                        <LassoIcon style={iconStyle}/>
                    </Button>
                    {this.renderBrushButton(BRUSHES[1])}
                    <Button
                        active={mode === INVERSE && shape !== RECT}
                        data-tip
                        data-for="inverseTooltip"
                        className="btn-inverse"
                        onClick={() => onModeChanged(INVERSE, FREEHAND)}
                    >
                        <LassoInverseIcon style={iconStyle}/>
                    </Button>
                    {this.renderBrushButton(BRUSHES[2])}
                    <Button
                        active={mode === LASSO && shape === RECT}
                        data-tip
                        data-for="rectTooltip"
                        className="btn-lasso"
                        onClick={() => onModeChanged(LASSO, RECT)}
                    >
                        <RectIcon style={iconStyle}/>
                    </Button>
                    {this.renderBrushButton(BRUSHES[3])}
                    <Button
                        active={mode === INVERSE && shape === RECT}
                        data-tip
                        data-for="inverseRectTooltip"
                        className="btn-inverse"
                        onClick={() => onModeChanged(INVERSE, RECT)}
                    >
                        <RectInverseIcon style={iconStyle}/>
                    </Button>
                </div>
                <ReactTooltip id="brushTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Brush'}</div>
                    <kbd>{'b'}</kbd>
                </ReactTooltip>
                <ReactTooltip id="lassTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Lasso'}</div>
                    <kbd>{'l'}</kbd>
                </ReactTooltip>
                <ReactTooltip id="inverseTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Inverse Lasso'}</div>
                    <kbd>{'l'}</kbd>
                </ReactTooltip>
                <ReactTooltip id="rectTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Rectangular Lasso'}</div>
                    <kbd>{'l'}</kbd>
                </ReactTooltip>
                <ReactTooltip id="inverseRectTooltip" place="bottom" delayShow={400} className="light-tool-tip" type="light">
                    <div>{'Inverse Rectangular Lasso'}</div>
                    <kbd>{'l'}</kbd>
                </ReactTooltip>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PaintModePicker.js